module.exports = __webpack_public_path__ + "static/img/Pay-at-counter.18e2cbb9.svg";